import { render } from "./sales-returns-modal.vue?vue&type=template&id=296067e4"
import script from "./sales-returns-modal.vue?vue&type=script&lang=js"
export * from "./sales-returns-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__